import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

export function useContentStyles() {
  const { effects, fonts, semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      content: {
        "& > .ms-Dialog-inner > .ms-Dialog-content > .carousel-root > .carousel-slider > ul > li": {
          backgroundColor: semanticColors.bodyBackground,
          color: semanticColors.bodyText,
          height: `10px`,
          opacity: 1,
          width: `10px`
        },
        "& > .ms-Dialog-inner > .ms-Dialog-content > .carousel-root > .carousel-slider > ul > .selected": {
          backgroundColor: semanticColors.primaryButtonBackground,
          boxShadow: effects.elevation64,
          height: `12px`,
          width: `12px`
        }
      },
      modal: {
        "> .ms-Dialog-main": {
          height: `500px`,
          maxWidth: `800px`,
          minWidth: `800px`
        }
      },
      carousel: {
        "> .carousel-slider > p": {
          backgroundColor: semanticColors.bodyBackground,
          color: semanticColors.bodyText,
          marginTop: `-1px`,
          ...fonts.smallPlus,
          fontWeight: 600
        },
        "> .carousel-slider > .slider-wrapper > .slider > .slide > img": {
          height: `420px`,
          visibility: `hidden`,
          width: `auto`
        },
        "> .carousel-slider > .slider-wrapper > .slider > .selected > img": {
          visibility: `visible`
        }
      }
    }),
    [effects, fonts, semanticColors]
  );
}
